// extracted by mini-css-extract-plugin
export default {"root":"classes_root__wmsqJ","title-container":"classes_title-container__WcAqM","content":"classes_content__PFKsz","button-container":"classes_button-container__R41rC"};